module.exports = __webpack_public_path__ + "media/img/frontend_application/video-icon-919c52c7227f1f2cc04cad9fff42b8ab.png";